import { ApiSignInOkResponse } from "@goodfill/backend-api-client";
import { UserAuthState } from "../../state";

export const mapLoginDataToUserState = (logInData: ApiSignInOkResponse): UserAuthState => {
  return {
    user: {
      userId: logInData.userData.Username,
      username: logInData.userData.UserAttributes.find((attr) => attr.Name === "email")?.Value ?? "",
    },
    idToken: logInData.auth.AuthenticationResult.IdToken,
    refreshToken: logInData.auth.AuthenticationResult.RefreshToken,
  };
};
